import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

export function initSingleStoreImageSlider()
{
    const imageSlider = document.querySelectorAll(".single-store-slider");

    let imageSwiper = [];

    for (let i = 0; i < imageSlider.length; i++) {
        imageSwiper[i] = new Swiper(imageSlider[i], {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 25,
        breakpoints: {
            640: {
            slidesPerView: 2,
            },
            920: {
            slidesPerView: 3,
            },
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
        });
    }
}